export default {
  parameters: {
    landing_id: "MxAuRoblox",
  },
  downtimeUrl: "https://cl.kodland.tech",
  startPage: {
    image: "/welcome/quiz_latam_roblox2_pk.png",
    imageMobile: "/welcome/quiz_latam_roblox2_mobile.png",
    title: "Responde 3 preguntas y recibe una clase gratuita de programación en Roblox para tu hijo/a",
    subtitle: "En 60 minutos, tu hijo/a aprenderá las bases de la programación y podrá crear su primer proyecto: ¡un videojuego! 👾",
    button: "Comenzar",
  },
  successPage: {
    title: "¡Felicitaciones! 🎁",
    subtitle: "Haz clic en '📆 Reservar una clase' para completar el registro",
    button: "📆 Reservar una clase",
  },
  stopPage: {
    image: "/welcome/quiz_stop_page.jpg",
    title: "¡Gracias por confiar en nuestra plataforma educativa! Desafortunadamente, las tabletas o los teléfonos no son adecuados para tomar nuestras lecciones. ¡Estaremos felices de verlos en nuestras aulas la próxima vez!",
  },
  quizRotateBySteps: {
    1: {
      question:
        "Te gustaría que el tiempo que tu hijo/a pasa en el computador fuera más productivo con la programación?",
      answers: ["🔥 ¡Si!", "🤗 No. Lo hace solo para divertirse y eso está bien"],
    },
    2: {
      question: "¿Cuáles son las habilidades de tu hijo/a con la computadora/portátil?",
      answers: [
        "👍 No tiene conocimientos, debe estudiar lo básico",
        "🙌 Nivel básico, sabe usar Power Point y otras aplicaciones",
        "🖥 Nivel intermedio, quiere profundizar conocimientos",
        "🕹 Usa los dispositivos más que nada para juegos",
      ],
    },
    3: {
      question:
        "¿Qué es lo que más quieres que tu hijo/a desarrolle con la codificación en Roblox?",
      answers: [
        "🧑‍🎨 Mejorar la creatividad del niño/s",
        "🖥 Aprender a programar y escribir código",
        "📈 Adquirir habilidades tecnológicas prácticas",
        "❓ Aún no lo sé",
      ],
    },
    4: {
      question: "¿Tienes una computadora de escritorio/portátil donde puedas trabajar?",
      answers: [
        "💻 Sí",
        {
          answer: "😐 No",
          stopAnswer: true
        },
      ],
    },
  },
};


